module.exports = __webpack_public_path__ + "img/heart_2_bj.5fb3a71f.png";